<template>
  <div :class="['layout-view', offset]">
    <controls-panel v-if="this.$route.params.farm_id && this.$route.params.farm_id !== '-1'"></controls-panel>
    <blanks-panel @farm-selected="onFarmSelected"></blanks-panel>
    <blanks-table></blanks-table>
  </div>
</template>

<script>
import adaptationMixin from '@/mixins/adaptation.mixin.js'
import BlanksPanel from './common/BlanksPanel'
import ControlsPanel from './ControlsPanel'
import BlanksTable from './table/Blanks'

export default {
  name: 'Blanks',

  mixins: [adaptationMixin],
  data: () => ({
    show: false
  }),
  components: {
    ControlsPanel,
    BlanksTable,
    BlanksPanel
  },
  computed: {
    offset () {
      return {
        'layout-view--offset-top': !this.$route.params.farm_id
      }
    }
  },
  methods: {
    onFarmSelected (farmId, companyId) {
      const route = farmId !== '-1' ? `/app/admin/blanks/companies/${companyId}/farms/${farmId}` : '/app/admin/blanks'

      this.$router.push(route)
    }
  }
}
</script>
